
import { defineComponent } from "vue";
import { ComponentName } from "../constants";
import gradient from "random-gradient";
import { DropdownOption } from "./eb-thumbnail-card-types";
import { getGradient } from "@/data/providers/global-provider";

export default defineComponent({
	name: ComponentName.EbThumbnailCard,
	props: {
		title: {
			type: String
		},
		subtitle: {
			type: String
		},
		image: {
			type: String
		},
		visible: {
			type: Boolean,
			default: true
		},
		gradientImage: {
			type: String
		},
		dropdownOptions: {
			type: Object as () => DropdownOption
		},
		thumbnailGradient: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		},
	},
	emits: ["cardClick"],
	setup() {
		return { gradient, getGradient };
	},
	data() {
		return {
			isOpen: false
		};
	},
	methods: {
		closeDropdown() {
			this.isOpen = false;
		}
	}
});
